import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "subscription-content" }
const _hoisted_2 = { class: "subscription-content__congratulation" }
const _hoisted_3 = { class: "subscription-content__congratulation__title" }
const _hoisted_4 = { class: "subscription-content__footer" }

import Button from "@/components/UI/Button/Button.vue";
import FullPopup from "@/components/UI/Pupup/FullPopup.vue";
import ProLabelBig from "@/components/UI/Label/ProLabelBig.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'SubscribedPopup',
  props: {
    "show": {},
    "showModifiers": {},
  },
  emits: ["update:show"],
  setup(__props) {


const show = _useModel(__props, 'show')
const onClick = () => {
  show.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FullPopup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    theme: "dark",
    closed: "",
    padding: false,
    "max-height": 410
  }, {
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "subscription-preview" }, [
        _createElementVNode("div", { class: "subscription-preview__about" }, "О подписке")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "subscription-content__congratulation__subtitle" }, "Поздравляем!", -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createTextVNode("Вы теперь ")),
            _createVNode(ProLabelBig)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Button, {
            text: "Ооочень хорошо",
            active: "",
            class: "subscription-content__footer__button",
            onClick: onClick
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})